// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3F4F0","head":"Table_head__yl1-9","col":"Table_col__tkQva"};